import { enableProdMode } from '@angular/core';
import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';
import * as Sentry from "@sentry/angular";

import { AppModule } from './app/app.module';
import { environment } from './environments/environment';

if (environment.production) {
  Sentry.init({
    dsn: "https://43d8a3ac9b65419f8b074c3faca0ed85@o4505001922396160.ingest.sentry.io/4505045642575872",
    allowUrls: [/https?:\/\/((api|files|cdn|certificates)\.)?smartlions\.center/],
    // Sentry 11 collects user info, cookies, headers and request bodies by default; keep the
    // pre-11 (sendDefaultPii: false) footprint.
    dataCollection: { userInfo: false, cookies: false, httpHeaders: false, httpBodies: [] },
    // This sets the sample rate to be 10%. You may want this to be 100% while
    // in development and sample at a lower rate in production
    replaysSessionSampleRate: 0.1,
    // If the entire session is not sampled, use the below sample rate to sample
    // sessions when an error occurs.
    replaysOnErrorSampleRate: 1.0,

    integrations: [
      Sentry.browserTracingIntegration(),
      Sentry.replayIntegration({
        maskAllText: false,
        blockAllMedia: true,
      }),
    ],
    // Set tracesSampleRate to 1.0 to capture 100%
    // of transactions for performance monitoring.
    // We recommend adjusting this value in production
    tracesSampleRate: 0.4,
    tracePropagationTargets:["localhost", "https://api.smartlions.center", "*"],
  });
  enableProdMode();
}

// Zone change detection (with event coalescing) is configured in AppModule's providers; the
// bootstrap options are no longer read since Angular 21.
platformBrowserDynamic().bootstrapModule(AppModule)
  .catch(err => console.error(err));